module.exports = __webpack_public_path__ + "img/none_video.ba160531.png";